const SectionLabel = ({ children }) => (
  <p className="font-mono text-[11px] tracking-[0.25em] uppercase text-white/35 mb-5">
    {children}
  </p>
);

export default SectionLabel;